import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faArrowRightLong,
  faArrowTrendDown,
  faArrowTrendUp,
  faBan,
  faCheck,
  faCheckCircle,
  faCircleInfo,
  faClock,
  faPersonCircleQuestion,
  faPiggyBank,
  faStar,
  faTriangleExclamation,
} from "@fortawesome/pro-solid-svg-icons";

export const initSolidIcons = () => {
  library.add(
    faArrowRightLong,
    faArrowTrendDown,
    faArrowTrendUp,
    faBan,
    faCheck,
    faCheckCircle,
    faCircleInfo,
    faClock,
    faPersonCircleQuestion,
    faPiggyBank,
    faStar,
    faTriangleExclamation,
  );
};
